import { z } from 'zod';
/** Identifiants : cuid2 côté Prisma, mais on ne valide que la forme générale. */
export const idSchema = z.string().min(1).max(64);
export const emailSchema = z.email({ message: 'Adresse email invalide.' }).toLowerCase().trim();
export const pseudoSchema = z
    .string()
    .trim()
    .min(2, 'Le pseudo doit faire au moins 2 caractères.')
    .max(24, 'Le pseudo ne peut pas dépasser 24 caractères.');
/** Les dates traversent l'API en ISO 8601. Le front les reconvertit en `Date`. */
export const isoDateSchema = z.iso.datetime({ message: 'Date ISO 8601 attendue.' });
/**
 * De quoi afficher un membre à côté de ce qu'il a produit : une pastille et un nom.
 *
 * Cette forme était recopiée dans chaque vue qui attribue quelque chose à quelqu'un —
 * `broughtBy` d'un rhum, `member` d'une note. Trois copies suffisaient à laisser passer une
 * quatrième qui aurait oublié `avatarUrl`, et le front aurait affiché une initiale nue sans
 * que rien ne le signale. Aucune donnée personnelle ici : pseudo et avatar, jamais l'email.
 */
export const memberSummarySchema = z.object({
    id: idSchema,
    pseudo: z.string(),
    avatarUrl: z.string().nullable(),
});
/** Pagination commune à toutes les listes. */
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(100).default(24),
});
//# sourceMappingURL=common.js.map